import React, { useMemo } from "react";
import Model from "@tripian/model";

// Icon Components
const UserIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const MapIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
    <line x1="8" y1="2" x2="8" y2="18" />
    <line x1="16" y1="6" x2="16" y2="22" />
  </svg>
);

const CheckCircleIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);


type Props = {
  t: (value: Model.TranslationKey) => string;
};

const HowItWorks: React.FC<Props> = ({ t }) => {

    const stepsData = [
        {
            titleKey: t('valai.howItWorks.YourAccount'),
            descriptionKey: t('valai.howItWorks.YourAccount.desc'),
            icon: UserIcon,
        },
        {
            titleKey: t('valai.howItWorks.YourPlan'),
            descriptionKey: t('valai.howItWorks.YourPlan.desc'),
            icon: MapIcon,
        },
        {
            titleKey: t('valai.howItWorks.ReadyToGo'),
            descriptionKey: t('valai.howItWorks.ReadyToGo.desc'),
            icon: CheckCircleIcon,
        },
    ];

    const steps = useMemo(
    () =>
      stepsData.map(item => ({
        title: t(item.titleKey as Model.TranslationKey),
        description: t(item.descriptionKey as Model.TranslationKey),
        icon: item.icon,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
      <div className="max-w-7xl mx-auto pd-start-trip-bg border-radius-12-c" style={{ backgroundColor: "#E7EDFE" }}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
              {steps.map((step, index) => {
                  const IconComponent = step.icon;
                  return (
                      <div
                          key={index}
                          className="flex flex-col items-center text-center"
                      >
                          {/* Icon Container */}
                          <div className="w-16 h-16 mb-6 rounded-full bg-[#C7D2FE] flex items-center justify-center">
                              <div className="text-[#4F46E5]">
                                  <IconComponent />
                              </div>
                          </div>

                          {/* Title */}
                          <h3 className="font-18-h text-[#0B1215] mb-3 syne-fm">
                              {step.title}
                          </h3>

                          {/* Description */}
                          <p className="font-14-h text-[#6B7280] leading-relaxed max-w-sm">
                              {step.description}
                          </p>
                      </div>
                  );
              })}
          </div>
      </div>
  );
};

export default HowItWorks;